import { render, staticRenderFns } from "./InputPeopleNum.vue?vue&type=template&id=516c3314&scoped=true&"
import script from "./InputPeopleNum.vue?vue&type=script&lang=js&"
export * from "./InputPeopleNum.vue?vue&type=script&lang=js&"
import style0 from "./InputPeopleNum.vue?vue&type=style&index=0&id=516c3314&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c3314",
  null
  
)

export default component.exports